import * as React from 'react'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { DraftLeadFilters } from './DraftLeadFilters'
import FilterButton from '../../Filters'
import { selectDraftLeadFilters } from '@user/store/draftLeads/slice'
import { useSaveDraftLeadFilters } from '@user/store/draftLeads/hooks'
import { DraftLead } from '@user/store/draftLeads/typings'
import {
  DraftLeadFilterSet,
  defaultFilters,
  orderByOptions,
} from '@user/store/draftLeads/filters'
import { CardListViewMode } from '@sales-center/components'
import { validateDraftLeadFilters } from './utils'
import { useLocation } from 'react-router-dom'

export const DraftLeadPageFilterButton: FC<{
  mode: CardListViewMode
  disabled: boolean
}> = ({ mode, disabled }) => {
  const saveDraftLeadFilters = useSaveDraftLeadFilters()
  const { filterSet } = useSelector(selectDraftLeadFilters)
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const importName = params.get('importNameFilter')
  const importId = params.get('importIdFilter')

  useEffect(() => {
    if (importName) {
      saveDraftLeadFilters({
        ...defaultFilters,
        filters: {
          ...defaultFilters.filters,
          importId: {
            ...defaultFilters.filters.importId,
            value: {
              mode: 'any',
              options: [{ value: importId, label: importName }],
            },
          },
        },
      })
      history.replaceState(null, '', `/#${location.pathname}`)
    }
  }, [importName])

  return (
    <FilterButton<DraftLead, DraftLeadFilterSet>
      applyCallback={saveDraftLeadFilters}
      defaultValues={defaultFilters}
      clearedValues={defaultFilters}
      filterComponent={DraftLeadFilters}
      initialValues={filterSet}
      orderOptions={orderByOptions}
      hideOrderBy={mode === 'list'}
      disabled={disabled}
      validate={validateDraftLeadFilters}
    />
  )
}

DraftLeadPageFilterButton.displayName = 'DraftLeadPageFilterButton'
